import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import CardSlider from '../components/Slider/CardSlider'
import FlipCardSlider from '../components/Slider/FlipCardSlider'
import CardSlider2 from '../components/Slider/CardSlider2'
import Accordion from '../components/Accordion/Accordion'
import RoiCTA from '../components/CTA/RoiCTA'
import FeaturedContent from '../components/Featured/FeaturedContent'
import CardContainer from '../components/Card/CardContainer'
import Card from '../components/Card/Card'
import { useModal } from '../context/ModalContext'

const SolutionDetails = () => {
    const { openModal } = useModal();
    useEffect(()=> {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      },[]);
    return (
        <>
            <div className='about-hero w-100'
            // style={{backgroundImage: "url(images/about/bg2.webp)"}}
            >
                <img src="/images/about/bg7.jpg" alt="" className='w-100' style={{ objectFit: "cover" }} />
                <div className="row position-absolute p-5 w-100" style={{ top: '80px' }}>
                    <div className="col col-12 col-lg-6 px-5" style={{ backgroundColor: "#ffff00b0" }}>
                        <p className="fs-1 text-light mb-5">

                        </p>
                        <h1 className='text-dark fw-bold mb-4'>
                            Intelligent AI Dashcam
                            video solutions
                        </h1>
                        <p className='fs-5 text mb-5'>Our AI Dashcams utilize artificial intelligence for real time detection
                            of distracted driving and road hazards to help optimize fleet safety.</p>
                        <div className="d-flex pb-5">
                            <button className="btn btn-dark rounded-5" onClick={openModal}>See Plans & Pricing</button>
                            <Link className='ms-3 btn btn-link text-dark fw-bold text-decoration-none'>Get a Demo</Link>
                        </div>
                    </div>
                </div>
            </div>
            <RoiCTA />
            <FeaturedContent />

            <div className="container">
                <div className="row align-items-center">
                    <div className="col col-12 col-lg-4 ps-lg-5">
                        <h1 className='mb-4'>Fleet dash cams have a live view of the road</h1>

                        <p className='mb-5'>
                            Take control of fleet safety to help prevent accidents. Automatically play audible in-cab alerts in real time for drivers who are distracted, and review road- and driver-facing camera footage side by side.
                        </p>
                        <button className='btn btn-outline-dark btn-lg rounded-5'>See Plan & Pricing</button>
                    </div>
                    <div className="col">
                        <img src="https://assets.verizonconnect.com/cdn-cgi/image/width=1294,height=830,format=auto/solutions/fleet-dash-cam/us-coaching-insights.png" alt="" className='w-100 pt-5 p-lg-5 pe-0' />
                    </div>
                </div>

            </div>
            <div className='my-5'>
                <CardSlider2 />
            </div>
            

            <CardContainer heading="Benefits" desc="Get to know us through our associates and the impact we make together.">
                <Card
                    category="Safety"
                    bgColor="#f4f4f4"
                    type="primary"
                    headingColor="#0d004a"
                    heading="Boost your fleet's safety performance"
                    desc="AI-powered fleet dash cams can automatically alert drivers in real-time when they are distracted, too close, or falling asleep. Set up alerts to customize the driver experience."
                    imgsrc="https://emt.gartnerweb.com/ngw/globalassets/en/about/images/build-graphics/about-page-tree-planting.jpg"
                    linkText="See Plans & Pricing"

                />
                <Card
                    category="Visibility"
                    bgColor="#eaca13"
                    type="vibrant"
                    heading="Get the whole story in vivid HD video detail"
                    desc="Review HD video footage captured by your dash cam within minutes of the incident, allowing you to quickly assess driving events. The clips are classified and tagged with relevant context, empowering you to quickly take action."
                    imgsrc="https://emt.gartnerweb.com/ngw/globalassets/en/about/images/build-graphics/about-page-give-back.jpg"

                />
                <Card
                    category="Coaching insights"
                    type="primary"
                    heading="Coach drivers in safer driving habits"
                    desc="Use driving data and dash cam footage to coach drivers in safer driving practices and foster a culture of safety performance."
                    imgsrc="https://emt.gartnerweb.com/ngw/globalassets/en/about/images/build-graphics/about-page-join-us.jpg"
linkText="See Plans & Pricing"
                />
            </CardContainer>

            <div className="testimonials-section section">
                <div className="container">
                    <div className="section-header">
                        <h2>What our customers say</h2>
                    </div>
                    <div className="testimonial-container">
                        <div className="testimonial-card">
                            <div className="testimonial-logo">
                                <img
                                    src="https://conglobase.com/assets/media/Varients/SVG/conglobase_original.svg"
                                    alt=""
                                />
                            </div>
                            <div className="testimonial-content">
                                <div className="testimonial-text">
                                    <p>
                                        <i>
                                            "Shoora's solution is a game-changer. Fleet safety and
                                            efficiency soared since we partnered with them. Its a
                                            greatfull impact around the world."
                                        </i>
                                    </p>
                                </div>
                                <div className="testimonial-author">
                                    <h6>Santosh Kushwaha</h6>
                                    <p>Director, Conglobase</p>
                                </div>
                            </div>
                        </div>
                        <div className="testimonial-card">
                            <div className="testimonial-logo">
                                <img
                                    src="https://www.coretechinfra.com/assets/coretech_logo_blue-Cg93CoWY.png"
                                    alt=""
                                />
                            </div>
                            <div className="testimonial-content">
                                <div className="testimonial-text">
                                    <p>
                                        <i>
                                            "Shoora’s platform revolutionized our fleet management.
                                            Risk detection is unmatched. We’ve significantly reduced
                                            downtime and costs. Highly recommend!"
                                        </i>
                                    </p>
                                </div>
                                <div className="testimonial-author">
                                    <h6>Kailash Nath</h6>
                                    <p>Director, Coretech Infra</p>
                                </div>
                            </div>
                        </div>
                        <div className="testimonial-card">
                            <div className="testimonial-logo">
                                <img
                                    src="https://media.licdn.com/dms/image/C510BAQHsXS04-Fa3vA/company-logo_200_200/0/1631329964828?e=1729728000&v=beta&t=3oib2s9AE4CzkH3y_bey64lFHfdl0oJ7hkYSZYlZsIo"
                                    alt=""
                                />
                            </div>
                            <div className="testimonial-content">
                                <div className="testimonial-text">
                                    <p>
                                        <i>
                                            “Our customers need assurance—there is a definite value
                                            pool shift to solutions and services—partnering with
                                            Shoora is our value-creation initiative to re-assure our
                                            customers of safety ”
                                        </i>
                                    </p>
                                </div>
                                <div className="testimonial-author">
                                    <h6>Saurabh Sharma</h6>
                                    <p>Director, Saurya Technologies</p>
                                </div>
                            </div>
                        </div>
                        <div className="testimonial-card">
                            <div className="testimonial-logo">
                                <img
                                    src="https://mohawkind.com/_images/global/footerLogo.svg"
                                    alt=""
                                />
                            </div>
                            <div className="testimonial-content">
                                <div className="testimonial-text">
                                    <p>
                                        <i>
                                            “We’ve gone from having to give a two hour, stagnant
                                            delivery window—that our drivers would sometimes miss—to
                                            minute-by-minute updates for our customers.”
                                        </i>
                                    </p>
                                </div>
                                <div className="testimonial-author">
                                    <h6>MATT KIN</h6>
                                    <p>Director, Mohawk Industries</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container py-5">

                <div className='faq-section mb-5'>
                    <h1 className=' mb-3 text-center'>
                        Your questions about CabinVision, answered.
                    </h1>
                    <p className='text-center'>Get to know frequently asked questions.</p>
                    <Accordion />
                </div>
            </div>


        </>
    )
}

export default SolutionDetails;